import { useEffect } from 'react';
import { create } from 'zustand';
import { useLogin } from '@/lib/login';
import { fetchWalletDetails, type IxigoMoneyWallet } from './api';

type WalletState = {
	loading?: boolean;
	response?: {
		data?: IxigoMoneyWallet;
	};
	loadWallet: () => void;
};
const useWalletStore = create<WalletState>()((set, get) => ({
	loadWallet: () => {
		const { response, loading } = get();
		if (response || loading) {
			return;
		}
		set({ loading: true });
		return fetchWalletDetails()
			.catch(() => undefined)
			.then((res) => {
				set({ response: res, loading: false });
				return res;
			});
	},
}));

export function useIxigoMoney() {
	const { isUserLoggedIn } = useLogin();
	const { response, loadWallet, loading } = useWalletStore();

	useEffect(() => {
		if (isUserLoggedIn) {
			loadWallet();
		} else {
			useWalletStore.setState({ response: undefined });
		}
	}, [isUserLoggedIn, loadWallet]);
	return { data: response?.data, loading };
}
